import { render, staticRenderFns } from "./UserReferralChargesFilters.vue?vue&type=template&id=04e68d2e&"
import script from "./UserReferralChargesFilters.vue?vue&type=script&lang=js&"
export * from "./UserReferralChargesFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports